// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Jaimie",
  middleName: "",
  lastName: "Bertoli",
  message: "Software Developer located in NYC, passionate about collaborating and creating.",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/jaibean",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/jaimie-bertoli/",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/biopic.png"),
  imageSize: 375,
  message:
    "My name is Jaimie Bertoli. I am a self motivated developer with a strong business sense that enjoys working on a team. I am able to translate business problems to data driven solutions while quickly learning new technologies. Recently, I completed an intensive coding bootcamp to expand my skill sets as a backend developer. Python and JavaScript are the languages that intrigue me the most, but I am eager to integrate new technologies into my repertoire. Currently, I am building web apps with Python, Django, Flask, JavaScript, React, and RESTful APIs while searching for a full-time job.",
  resume: "https://docs.google.com/document/d/1-btCEBkn4msk69Jm_UoIg4whUg0UsRa2G9lfA6XVp_I/edit?usp=sharing",
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "jaibean", //i.e."johnDoe12Gh"
  reposLength: 0,
  specificRepos: ["LastFM_Spotify_API", "Django_book_web_app", "TicTacToe", "react-complete-guide"],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    { 
      img: require("../editable-stuff/biopic.png"), 
      label: "First slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
    { 
      img: require("../editable-stuff/biopic.png"), 
      label: "Second slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Python", value: 60 },
    { name: "SQL", value: 60 },
    { name: "Data Structures", value: 65 },
    { name: "JavaScript", value: 75 },
    { name: "React", value: 65 },
    { name: "HTML/CSS", value: 90 },
    { name: "C#", value: 50 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm currently looking for full-time Software Engineering or Front-End Developer roles! If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "jaimie.bertoli@gmail.com",
};

const experiences = {
  show: true,
  heading: "Experiences",
  data: [
    {
      role: 'Python/Django Developer',// Here Add Company Name
      company: 'A Free Bird',
      companylogo: require('../assets/img/afreebird.png'),
      date: 'June 2021 – Present',
    },
    {
      role: 'Software Engineer',
      company: 'Prosper I.T. Consulting',
      companylogo: require('../assets/img/prosperIT.png'),
      date: 'January 2021 – April 2021',
    },
    {
      role: 'Front-End Developer',
      company: 'JPMorgan Chase & Co.',
      companylogo: require('../assets/img/jpmc.png'),
      date: 'July 2019 – October 2020',
    },
    {
      role: 'Business Systems Analyst',
      company: 'JPMorgan Chase & Co.',
      companylogo: require('../assets/img/jpmc.png'),
      date: 'August 2016 – July 2019',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences };
